import { MessagesSquare, Sparkles } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { CheckList } from './shared';

// Section 8 — Coaching + Ask Amden. Ask Amden is described strictly as
// decision support grounded in the user's authorised Compass information.
export const CompassCoaching = ({ sp }) => (
  <section aria-labelledby="compass-coaching-heading" data-testid="compass-coaching" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="08"
        eyebrow="Coaching & Ask Amden"
        title="Coaching connected to the live business"
        description={sp.coachingCopy}
        testid="compass-coaching-header"
      />
      <div className="mt-14 grid gap-10 lg:grid-cols-2">
        <Reveal>
          <div className="h-full rounded-xl border border-slate-200 bg-mist p-7 sm:p-8" data-testid="compass-coaching-panel">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy-900 text-gold-500">
              <MessagesSquare className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-xl font-extrabold tracking-tight text-navy-900">Coaching</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              Coaching stays connected to the plan between sessions, so preparation, notes and agreed actions never sit in a separate notebook.
            </p>
            <div className="mt-6">
              <CheckList items={sp.coachingPoints || []} testid="compass-coaching-points" />
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex h-full flex-col rounded-xl bg-navy-900 p-7 sm:p-8" data-testid="compass-ask-amden-panel">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gold-500 text-navy-950">
              <Sparkles className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-xl font-extrabold tracking-tight text-white">Ask Amden</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">
              Decision support grounded in your authorised Compass information. Users can ask questions such as:
            </p>
            <ul className="mt-5 space-y-2.5">
              {(sp.askAmdenExamples || []).map((question) => (
                <li key={question} className="rounded-lg border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-slate-100">
                  “{question}”
                </li>
              ))}
            </ul>
            {sp.shots.askAmden?.src && (
              <img
                src={sp.shots.askAmden.src}
                alt={sp.shots.askAmden.alt}
                width={sp.shots.askAmden.width}
                height={sp.shots.askAmden.height}
                loading="lazy"
                className="mt-6 w-full rounded-lg border border-white/10"
                data-testid="compass-ask-amden-visual"
              />
            )}
            <p className="mt-5 text-xs leading-relaxed text-slate-400">
              Ask Amden works only with information the signed-in user is authorised to access in their Compass workspace. It supports — it does not replace — professional business judgement.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
